// extracted by mini-css-extract-plugin
module.exports = {"columnText":"OverviewTable_columnText__2XaCx"};